import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

export default function Footer() {
  return (
    <footer className="footer">
      <h3 id="content" className="da">
        *Igrice za turnir su odabrane isključivo na osnovu njihove popularnosti
        među srednjoškolcima i ni na koji način ne služe za promociju bilo
        kakvog vida nasilja.
      </h3>
    </footer>
  );
}
